import {BoxIcon, FinishIcon, Typography} from '@yandex-delivery/blocks'
import React, {type PropsWithChildren} from 'react'

import type {PlacemarkType} from '../types'
import * as classes from './PointPlacemarkIcon.classes'

type Props = PropsWithChildren<{
  type: PlacemarkType
}>

export function PointPlacemarkIcon({type, children}: Props): React.ReactElement {
  if (type === 'source') {
    return <BoxIcon className={classes.sourcePlaceMark} />
  }

  if (type === 'destination') {
    return <FinishIcon />
  }

  return (
    <Typography thickness="medium" variant="body1">
      {children}
    </Typography>
  )
}
